export function Icon(props: { iconComponent?: React.ComponentType }) {
  if (!props || !props.iconComponent) return <></>;

  const IconClass: React.ComponentType = props.iconComponent;
  return <IconClass />;
}
